<template>
  <div class="customBarCodes">
    <div v-for="row in products" :key="row.id" style="background-color: white">
      <center>
        <barcode
          :value="'(' + row.id + ') ' + row.price + 'DT'"
          :options="{
            lineColor: '#000',
            text: '(' + row.id + ') ' + row.price + 'DT',
            fontOptions: 'bold',
            fontSize: 30,
          }"
        ></barcode>
        <div class="customP">
          <b>{{ row.name }}</b>
        </div>
        <div class="customP">
          <b>{{ getDate(row.createdOn) }}</b>
        </div>
      </center>
      <br /><br />
    </div>
  </div>
</template>
<script>
import { Printd } from "printd";

export default {
  props: {
    products: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getDate(date) {
      const dDate = new Date(date);
      const day = dDate.getDate() > 9 ? dDate.getDate() : "0" + dDate.getDate();
      const realMonth = dDate.getMonth() + 1;
      const month = realMonth > 9 ? realMonth : "0" + realMonth;
      const year = dDate.getFullYear();
      return `${day}/${month}/${year}`;
    },
    printMe() {
      console.log(this.products);
      const d = new Printd();
      d.print(this.$el, [
        `.customP {font-weight: bold;font-size:24px !important; color: #000; margin: 0 !important; padding: 0px !important;}`,
      ]);
    },
  },
};
</script>
<style>
.customBarCodes div {
  font-size: 24px;
}
.customP {
  font-weight: bold;
  font-size: 24px !important;
  color: #000;
  margin: 0 !important;
  padding: 0px !important;
}
</style>